"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _router = _interopRequireDefault(require("@/router"));
var _services = require("@/services");
var MutationTypes = _interopRequireWildcard(require("../mutation-types"));
var _helpers = require("@/helpers");
var _underLoading = require("../helpers/under-loading");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t8 in e) "default" !== _t8 && {}.hasOwnProperty.call(e, _t8) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t8)) && (i.get || i.set) ? o(f, _t8, i) : f[_t8] = e[_t8]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var state = {
  user: {}
};
var mutations = _defineProperty(_defineProperty({}, MutationTypes.SET_CURRENT_USER, function (state, user) {
  state.user = user;
}), MutationTypes.RESET_CURRENT_USER, function (state, user) {
  state.user = {};
});
var getters = {
  userAdmin: function userAdmin(state) {
    return state.user;
  }
};
var actions = {
  authAdmin: (0, _underLoading.underLoadingFunction)(/*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(_ref, _ref2) {
      var commit, dispatch, email, password, remember, _yield$authService$lo, data, _t;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            commit = _ref.commit, dispatch = _ref.dispatch;
            email = _ref2.email, password = _ref2.password, remember = _ref2.remember;
            _context.p = 1;
            _context.n = 2;
            return _services.authService.login(email, password);
          case 2:
            _yield$authService$lo = _context.v;
            data = _yield$authService$lo.data;
            _services.authService.addUserToSession(data);
            commit(MutationTypes.SET_CURRENT_USER, data);
            return _context.a(2, data);
          case 3:
            _context.p = 3;
            _t = _context.v;
            _helpers.errorResponseHelper.display(_t);
            return _context.a(2, false);
        }
      }, _callee, null, [[1, 3]]);
    }));
    return function (_x, _x2) {
      return _ref3.apply(this, arguments);
    };
  }()),
  // eslint-no-trailing-spaces
  forgotPasswordOwner: (0, _underLoading.underLoadingFunction)(/*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(_ref4, _ref5) {
      var commit, dispatch, email, successMessage, _t2;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.p = _context2.n) {
          case 0:
            commit = _ref4.commit, dispatch = _ref4.dispatch;
            email = _ref5.email;
            _context2.p = 1;
            _context2.n = 2;
            return _services.authService.forgotPasswordOwner(email);
          case 2:
            successMessage = _router.default.app.$t('pages.recover_password.msg_send_success');
            _helpers.messageHelper.success(successMessage);
            return _context2.a(2, true);
          case 3:
            _context2.p = 3;
            _t2 = _context2.v;
            _helpers.errorResponseHelper.display(_t2);
            return _context2.a(2, false);
        }
      }, _callee2, null, [[1, 3]]);
    }));
    return function (_x3, _x4) {
      return _ref6.apply(this, arguments);
    };
  }()),
  resetPasswordAdmin: (0, _underLoading.underLoadingFunction)(/*#__PURE__*/function () {
    var _ref9 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(_ref7, _ref8) {
      var commit, dispatch, password, token, successMessage, _t3;
      return _regenerator().w(function (_context3) {
        while (1) switch (_context3.p = _context3.n) {
          case 0:
            commit = _ref7.commit, dispatch = _ref7.dispatch;
            password = _ref8.password, token = _ref8.token;
            _context3.p = 1;
            _context3.n = 2;
            return _services.authService.resetPasswordOwner(password, token);
          case 2:
            successMessage = _router.default.app.$t('pages.change_password.msg_send_success');
            _helpers.messageHelper.success(successMessage);
            return _context3.a(2, true);
          case 3:
            _context3.p = 3;
            _t3 = _context3.v;
            _helpers.errorResponseHelper.display(_t3);
            return _context3.a(2, false);
        }
      }, _callee3, null, [[1, 3]]);
    }));
    return function (_x5, _x6) {
      return _ref9.apply(this, arguments);
    };
  }()),
  resendEmail: (0, _underLoading.underLoadingFunction)(/*#__PURE__*/function () {
    var _ref10 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(_ref0, _ref1) {
      var commit, dispatch, email, successMessage, _t4;
      return _regenerator().w(function (_context4) {
        while (1) switch (_context4.p = _context4.n) {
          case 0:
            commit = _ref0.commit, dispatch = _ref0.dispatch;
            email = _ref1.email;
            _context4.p = 1;
            _context4.n = 2;
            return _services.authService.resendEmail(email);
          case 2:
            successMessage = _router.default.app.$t('pages.login.alerts.resend_confirm');
            _helpers.messageHelper.success(successMessage);
            return _context4.a(2, true);
          case 3:
            _context4.p = 3;
            _t4 = _context4.v;
            _helpers.errorResponseHelper.display(_t4);
            return _context4.a(2, false);
        }
      }, _callee4, null, [[1, 3]]);
    }));
    return function (_x7, _x8) {
      return _ref10.apply(this, arguments);
    };
  }()),
  confirmRegistration: (0, _underLoading.underLoadingFunction)(/*#__PURE__*/function () {
    var _ref13 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(_ref11, _ref12) {
      var commit, dispatch, token, user, successMessage, _t5;
      return _regenerator().w(function (_context5) {
        while (1) switch (_context5.p = _context5.n) {
          case 0:
            commit = _ref11.commit, dispatch = _ref11.dispatch;
            token = _ref12.token, user = _ref12.user;
            _context5.p = 1;
            _context5.n = 2;
            return _services.authService.confirmRegistration(token, user);
          case 2:
            successMessage = _router.default.app.$t('pages.confirm_registration.msg_send_success');
            _helpers.messageHelper.success(successMessage);
            return _context5.a(2, true);
          case 3:
            _context5.p = 3;
            _t5 = _context5.v;
            _helpers.errorResponseHelper.display(_t5);
            return _context5.a(2, false);
        }
      }, _callee5, null, [[1, 3]]);
    }));
    return function (_x9, _x0) {
      return _ref13.apply(this, arguments);
    };
  }()),
  registerOwner: (0, _underLoading.underLoadingFunction)(/*#__PURE__*/function () {
    var _ref15 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(_ref14, payload) {
      var commit, dispatch, data, _yield$authService$re, user, successMessage, message, switchObj, err, _t6;
      return _regenerator().w(function (_context6) {
        while (1) switch (_context6.p = _context6.n) {
          case 0:
            commit = _ref14.commit, dispatch = _ref14.dispatch;
            _context6.p = 1;
            data = {
              firstName: payload.firstName,
              lastName: payload.lastName,
              cpf: payload.cpf.match(/\d+/)[0],
              email: payload.email,
              phone: payload.phone.replace(/\D/g, ''),
              password: payload.password,
              terms: payload.terms,
              termsAccept: payload.termsAccept,
              location: payload.location
            };
            _context6.n = 2;
            return _services.authService.registerOwner(data);
          case 2:
            _yield$authService$re = _context6.v;
            user = _yield$authService$re.data;
            successMessage = _router.default.app.$t('pages.signup.account_create_success');
            _helpers.messageHelper.success(successMessage);
            return _context6.a(2, {
              success: true,
              data: user
            });
          case 3:
            _context6.p = 3;
            _t6 = _context6.v;
            message = _t6.data ? _t6.data.message : _t6.response ? _t6.response.data.message : 'cpf_already_exists';
            switchObj = _defineProperty(_defineProperty({}, "An user with the specified \"Email\" already exists.", 'email_already_exists'), "An user with the specified \"cpf\" already exists.", 'cpf_already_exists');
            message = switchObj[message];
            err = {
              response: {
                data: {
                  message: message
                }
              }
            };
            _helpers.errorResponseHelper.display(err);
            return _context6.a(2, {
              success: false,
              data: _t6
            });
        }
      }, _callee6, null, [[1, 3]]);
    }));
    return function (_x1, _x10) {
      return _ref15.apply(this, arguments);
    };
  }()),
  logout: (0, _underLoading.underLoadingFunction)(/*#__PURE__*/function () {
    var _ref17 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7(_ref16, payload) {
      var commit, dispatch, _t7;
      return _regenerator().w(function (_context7) {
        while (1) switch (_context7.p = _context7.n) {
          case 0:
            commit = _ref16.commit, dispatch = _ref16.dispatch;
            _context7.p = 1;
            commit(MutationTypes.RESET_CURRENT_USER);
            dispatch('resetFarm');
            return _context7.a(2, true);
          case 2:
            _context7.p = 2;
            _t7 = _context7.v;
            _helpers.errorResponseHelper.display(_t7);
            return _context7.a(2, false);
        }
      }, _callee7, null, [[1, 2]]);
    }));
    return function (_x11, _x12) {
      return _ref17.apply(this, arguments);
    };
  }())
};
var _default = exports.default = {
  state: state,
  mutations: mutations,
  getters: getters,
  actions: actions
};